import { GleapTicket, GleapTicketsResponse } from '@models/GleapTicket'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { GLEAP_TICKETS_URL } from '../utils/urls'

// Tenant scoping is enforced server-side (filtered on the session company name),
// so no tenant param is sent here. This endpoint takes plain page/pageSize
// query params, not the TableParams f_/s_ scheme.
const fetchGleapTickets = (page = 1, pageSize = 20) =>
  SBAPI.Fetch<GleapTicketsResponse>(GLEAP_TICKETS_URL, { page, pageSize })

const FETCH_ALL_PAGE_SIZE = 100

// The endpoint has no status filter param, so status filtering happens client
// side. To keep filtering and pagination coherent, load every ticket once
// (paging through the server), then filter and paginate in the table.
const fetchAllGleapTickets = async (): Promise<GleapTicket[]> => {
  const first = await fetchGleapTickets(1, FETCH_ALL_PAGE_SIZE)
  const all = [...first.data.tickets]
  const pageCount = Math.ceil(first.data.pagination.total / FETCH_ALL_PAGE_SIZE)

  for (let page = 2; page <= pageCount; page++) {
    const response = await fetchGleapTickets(page, FETCH_ALL_PAGE_SIZE)
    all.push(...response.data.tickets)
  }

  return all
}

export { fetchAllGleapTickets, fetchGleapTickets }
